import '../sass/single-sale-content.scss';

(() => {
    const $singleSaleContents = document.querySelectorAll('.single-sale-content');

    if (!$singleSaleContents) return;

    $singleSaleContents.forEach($singleSaleContent => {
        const initIframe = () => {
            const $iframe = $singleSaleContent.querySelector('.single-sale-content__iframe');

            if (!$iframe) return;

            window.history.replaceState({
                iframeUrl: $iframe.src,
            }, '', window.location.href);

            iframeResize({
                license: 'GPLv3',
                onMessage(messageData) {
                    if (messageData?.message?.type === 'updateUrl') {
                        console.log('updateUrl', messageData);
                        
                        if (messageData?.message?.data?.url && messageData?.message?.data?.url !== window.location.href) {
                            const url = messageData?.message?.data?.url.replace('https://tattersalls-v2.orangerycreative.com', '');
                            
                            const state = {};
                            
                            if (messageData?.message?.data?.url?.split('/4DCGI/')?.[1]) {
                                state.iframeUrl = 'https://secure.tattersalls.com/4DCGI/' + url?.split('/4DCGI/')?.[1];
                            }
                            
                            window.history.replaceState(state, messageData?.message?.data?.title, url);

                            if (messageData?.message?.data?.title) {
                                document.title = messageData.message.data.title;
                            }
                        }

                        return;
                    }
                },
            }, $iframe);
        };

        window.addEventListener('popstate', e => {
            console.log('popstate', e.state);

            if (!e.state?.iframeUrl) return;
            
            const $iframe = $singleSaleContent.querySelector('.single-sale-content__iframe');
            
            const $newIframe = $iframe.cloneNode();
            $newIframe.src = e.state.iframeUrl;
            
            $iframe.parentNode.replaceChild($newIframe, $iframe);
            
            initIframe();
        });

        initIframe();
    });
})();
